import { useMemo, useRef } from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { extractValue } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function RHFField({
  name,
  format,
  normalize,
  component: Component,
  validate,
  onChange,
  onBlur,
  onFocus,
  warn,
  props
}) {
  const prevAllValues = useRef(undefined);
  const isActiveRef = useRef(false);
  const {
    control,
    getValues,
    trigger,
    formState: {
      isSubmitted
    }
  } = useFormContext();
  const {
    field,
    fieldState: {
      error,
      isTouched
    }
  } = useController({
    name,
    control,
    rules: {
      validate: validate ? value => validate(value, getValues()) : undefined
    }
  });
  const rawValue = useWatch({
    name,
    control
  });
  const value = format ? format(rawValue) : rawValue !== null && rawValue !== void 0 ? rawValue : '';
  const warning = useMemo(() => {
    if (!warn) {
      return undefined;
    }
    return warn(field.value, getValues());
  }, [field.value, warn, getValues]);
  const input = useMemo(() => {
    const handleChange = (eventOrValue, newValue) => {
      const val = newValue !== null && newValue !== void 0 ? newValue : extractValue(eventOrValue);
      const allValues = getValues();
      const currentValue = getValues(name);
      const normalized = normalize ? normalize(val, currentValue, allValues, prevAllValues.current) : val;
      prevAllValues.current = allValues;
      field.onChange(normalized);
      onChange === null || onChange === void 0 || onChange(normalized, newValue, currentValue, name);
    };
    const handleBlur = async () => {
      field.onBlur();
      await trigger(name);
      const currentValue = getValues(name);
      onBlur === null || onBlur === void 0 || onBlur(currentValue, undefined, prevAllValues.current, name);
      isActiveRef.current = false;
    };
    const handleFocus = event => {
      onFocus === null || onFocus === void 0 || onFocus(event, name);
      isActiveRef.current = true;
    };
    return {
      value,
      name,
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
      checked: typeof value === 'boolean' ? value : undefined
    };
  }, [value, name, normalize, onChange, onBlur, onFocus, field, getValues, trigger]);
  const meta = useMemo(() => ({
    touched: isTouched || isSubmitted,
    error: error === null || error === void 0 ? void 0 : error.message,
    warning: !error ? warning : undefined,
    invalid: Boolean(error),
    valid: !error
  }), [isTouched, isSubmitted, error, warning]);
  return /*#__PURE__*/_jsx(Component, {
    ...props,
    input: input,
    meta: meta
  });
}
//# sourceMappingURL=RHFAdaptedField.js.map